export const automaticComparisonDetailSearch = [
  {
    name: "plat_id",
    label: "运营商",
    pla: "请选择运营商",
    type: "select",
    dic: "OperatorArr",
  },
  {
    name: "parent_id",
    label: "归属代理商",
    pla: "请选择代理商",
    type: "select",
    dic: "AgentData1",
  },
  {
    name: "company_id",
    label: "企业",
    pla: "请选择企业",
    type: "select",
    dic: "CompanyData",
  },
];
